import React, { Component } from "react";
import { connect } from "react-redux";
import { Wrapper } from "./style.js";
import Printable from "./../../../../components/Printable";
import _ from "lodash";
import { domains } from "./../../../../modules/magnetDomains";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import Header from "./../Header";
import UnitMagnetScores from "./../../../../components/plotly/UnitMagnetScores";
import SRHCopyright from "./../../../../components/SRHCopyright";
import Grid from "@material-ui/core/Grid";
import { getBenchmarkLabel } from "../../../../lib/utils";

class DataTable extends Component {
  constructor(props) {
    super(props);
    this.getValue = this.getValue.bind(this);
    this.getBenchmark = this.getBenchmark.bind(this);
    this.passBenchmark = this.passBenchmark.bind(this);
    this.checkOrX = this.checkOrX.bind(this);
    this.insertBreaks = this.insertBreaks.bind(this);
  }

  getValue(unit, key) {
    const { magnetWorkSettings } = this.props;
    const magnetWorkSetting = magnetWorkSettings[unit];
    return magnetWorkSetting.domains[key][0].data[0].percent;
  }

  getBenchmark(unit, key) {
    const { magnetWorkSettings } = this.props;
    const magnetWorkSetting = magnetWorkSettings[unit];
    const appliedBenchmark = magnetWorkSetting.appliedBenchmark;
    return this.props.benchmarks.data[appliedBenchmark][key];
  }

  passBenchmark(unit, key) {
    const value = this.getValue(unit, key);
    const benchmark = this.getBenchmark(unit, key);
    return value > benchmark;
  }

  checkOrX(unit, key) {
    if (this.passBenchmark(unit, key)) {
      return <CheckIcon style={{ color: "#1cc7a0" }} />;
    } else {
      return <ClearIcon style={{ color: "#dd1a8e" }} />;
    }
  }

  insertBreaks(str) {
    return str.replace(/ /g, "<br>");
  }

  render() {
    const { ready, domainCombination, page, magnetReport, magnetWorkSettings } = this.props;
    const pageSize = 2;
    if (ready) {
      const datasetUnitName = magnetReport.datasetUnitName ? magnetReport.datasetUnitName : "Work Setting";
      const domainOne = _.find(domains, ["key", domainCombination.domainOne]);
      const domainTwo = _.find(domains, ["key", domainCombination.domainTwo]);
      const domainThree = _.find(domains, ["key", domainCombination.domainThree]);
      const domainFour = _.find(domains, ["key", domainCombination.domainFour]);
      const units = _.map(domainCombination.units, "name");
      const pages = [];
      while (pages.length * pageSize < units.length) {
        const pageStart = pages.length * pageSize;
        const pageOfUnits = [];
        for (let i = pageStart; i < pageStart + pageSize && i < units.length; i++) {
          pageOfUnits.push(units[i]);
        }
        pages.push(
          <Printable key={`page-${pages.length + 1}`} page={page + pages.length}>
            <Wrapper>
              {_.map(pageOfUnits, (unit, index) => {
                const appliedBenchmark = magnetWorkSettings[unit].appliedBenchmark;
                const benchmarkLabel = getBenchmarkLabel(appliedBenchmark);
                const benchmarkOne = this.getBenchmark(unit, domainOne.key);
                const benchmarkTwo = this.getBenchmark(unit, domainTwo.key);
                const benchmarkThree = this.getBenchmark(unit, domainThree.key);
                const benchmarkFour = this.getBenchmark(unit, domainFour.key);
                const showBenchmarkOne = typeof benchmarkOne === "number";
                const showBenchmarkTwo = typeof benchmarkTwo === "number";
                const showBenchmarkThree = typeof benchmarkThree === "number";
                const showBenchmarkFour = typeof benchmarkFour === "number";
                const noDataMessage = (
                  <Grid item className="column">
                    <div className="no-data">Insufficient number of responses to display results for this domain</div>
                  </Grid>
                );
                return (
                  <div key={`${index}-${unit}`}>
                    <Header title={unit} className={index === 1 ? "second-unit-graph" : ""} />
                    <UnitMagnetScores
                      x={[
                        this.insertBreaks(domainOne.name),
                        this.insertBreaks(domainTwo.name),
                        this.insertBreaks(domainThree.name),
                        this.insertBreaks(domainFour.name),
                      ]}
                      y={[
                        this.getValue(unit, domainOne.key),
                        this.getValue(unit, domainTwo.key),
                        this.getValue(unit, domainThree.key),
                        this.getValue(unit, domainFour.key),
                        // index === 0 ? pageStart * 4 + 0 : 100 - pageStart * 4 - 0,
                        // index === 0 ? pageStart * 4 + 1 : 100 - pageStart * 4 - 1,
                        // index === 0 ? pageStart * 4 + 2 : 100 - pageStart * 4 - 2,
                        // index === 0 ? pageStart * 4 + 3 : 100 - pageStart * 4 - 3,
                      ]}
                      benchmarks={[
                        benchmarkOne,
                        benchmarkTwo,
                        benchmarkThree,
                        benchmarkFour,
                        // index === 0 ? pageStart * 4 + 2 : 100 - pageStart * 4 + 2,
                        // index === 0 ? pageStart * 4 + 3 : 100 - pageStart * 4 + 1,
                        // index === 0 ? pageStart * 4 + 4 : 100 - pageStart * 4 + 0,
                        // index === 0 ? pageStart * 4 + 5 : 100 - pageStart * 4 + -1,
                      ]}
                    />
                    <div className="data-table">
                      <Grid container className="row">
                        <Grid item className="column">
                          {benchmarkLabel}
                        </Grid>
                        <Grid item className="column">
                          {showBenchmarkOne && `${benchmarkOne}%`}
                        </Grid>
                        <Grid item className="column">
                          {showBenchmarkTwo && `${benchmarkTwo}%`}
                        </Grid>
                        <Grid item className="column">
                          {showBenchmarkThree && `${benchmarkThree}%`}
                        </Grid>
                        <Grid item className="column">
                          {showBenchmarkFour && `${benchmarkFour}%`}
                        </Grid>
                      </Grid>
                      <Grid container className="row">
                        <Grid item className="column">
                          {datasetUnitName}
                        </Grid>
                        {showBenchmarkOne ? (
                          <Grid item className="column">
                            {this.checkOrX(unit, domainOne.key)}
                            {this.getValue(unit, domainOne.key)}%
                          </Grid>
                        ) : (
                          noDataMessage
                        )}
                        {showBenchmarkTwo ? (
                          <Grid item className="column">
                            {this.checkOrX(unit, domainTwo.key)}
                            {this.getValue(unit, domainTwo.key)}%
                          </Grid>
                        ) : (
                          noDataMessage
                        )}
                        {showBenchmarkThree ? (
                          <Grid item className="column">
                            {this.checkOrX(unit, domainThree.key)}
                            {this.getValue(unit, domainThree.key)}%
                          </Grid>
                        ) : (
                          noDataMessage
                        )}
                        {showBenchmarkFour ? (
                          <Grid item className="column">
                            {this.checkOrX(unit, domainFour.key)}
                            {this.getValue(unit, domainFour.key)}%
                          </Grid>
                        ) : (
                          noDataMessage
                        )}
                      </Grid>
                    </div>
                  </div>
                );
              })}
            </Wrapper>
            <SRHCopyright />
          </Printable>
        );
      }
      return pages;
    } else {
      return <Printable />;
    }
  }
}

export default connect(store => {
  return {
    magnetReport: store.magnetReport.magnetReport,
    magnetWorkSettings: store.magnetWorkSettings.magnetWorkSettings,
    benchmarks: store.benchmarks,
  };
})(DataTable);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/UnitGraphs/index.jsx